
import React from 'react';

const Features: React.FC = () => {
  const stats = [
    { number: '60,000+', label: 'Businesses worldwide' },
    { number: '45+', label: 'Apps included' },
    { number: '1000+', label: 'Interoperable integrations' }
  ];

  const companies = [
    'https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/aliens-tattoo.svg',
    'https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/enroute.png',
    'https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/cyberknight.png',
    'https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/caple.png',
    'https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/centilytics.png'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Rating Section */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="flex text-yellow-400 text-2xl mr-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill"></i>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">4.5/5</span>
          </div>
          <p className="text-gray-600 mb-4">based on 19,000+ reviews on</p>
          <div className="flex items-center justify-center space-x-8">
            <img src="https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/g2.svg" alt="G2" className="h-6" />
            <img src="https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/getapp-icon.svg" alt="GetApp" className="h-6" />
            <img src="https://www.zohowebstatic.com/sites/zweb/images/otherbrandlogos/capterra-icon.svg" alt="Capterra" className="h-6" />
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Trusted Companies */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Trusted by businesses worldwide</h3>
          <div className="flex flex-wrap items-center justify-center gap-8 opacity-60">
            {companies.map((logo, index) => (
              <img 
                key={index} 
                src={logo} 
                alt={`Company ${index + 1}`} 
                className="h-8 grayscale hover:grayscale-0 transition-all duration-300"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
